export default [
  {
    displayText: 'Any',
    value: null,
  }, {
    displayText: '$5,000 p.a.',
    value: 5000,
  }, {
    displayText: '$10,000 p.a.',
    value: 10000,
  }, {
    displayText: '$20,000 p.a.',
    value: 20000,
  }, {
    displayText: '$25,000 p.a.',
    value: 25000,
  }, {
    displayText: '$30,000 p.a.',
    value: 30000,
  }, {
    displayText: '$35,000 p.a.',
    value: 35000,
  }, {
    displayText: '$40,000 p.a.',
    value: 40000,
  }, {
    displayText: '$45,000 p.a.',
    value: 45000,
  }, {
    displayText: '$50,000 p.a.',
    value: 50000,
  }, {
    displayText: '$60,000 p.a.',
    value: 60000,
  }, {
    displayText: '$70,000 p.a.',
    value: 70000,
  }, {
    displayText: '$80,000 p.a.',
    value: 80000,
  }, {
    displayText: '$90,000 p.a.',
    value: 90000,
  }, {
    displayText: '$100,000 p.a.',
    value: 100000,
  }, {
    displayText: '$150,000 p.a.',
    value: 150000,
  }, {
    displayText: '$200,000 p.a.',
    value: 200000,
  }, {
    displayText: '$250,000 p.a.',
    value: 250000,
  }, {
    displayText: '$500,000 p.a.',
    value: 500000,
  }, {
    displayText: '$1,000,000 p.a.',
    value: 1000000,
  }, {
    displayText: '$2,000,000 p.a.',
    value: 2000000,
  },
];
